module.exports = __webpack_public_path__ + "img/RightStreakArrow.27ee01b2.svg";